import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: false,
};

export const ChatStatus = createSlice({
  name: "ChatStatus",
  initialState,
  reducers: {
    setChatStatus: (state) => {
      state.value = !state.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setChatStatus, setStatus } = ChatStatus.actions;

export default ChatStatus;
